interface FallbackProps {
  message: string;
}

export function Fallback({ message }: FallbackProps) {
  return (
    <div style={{
      width: '100%', height: '100%',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#0a0a0a', color: '#fff',
      textAlign: 'center', padding: '2rem',
    }}>
      <div style={{ fontSize: '2rem', fontWeight: 300, marginBottom: '0.5rem' }}>
        Koolyum Signage
      </div>
      <div style={{ opacity: 0.5, fontSize: '1rem' }}>
        {message}
      </div>
    </div>
  );
}
